var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaviWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60.78 60.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #717780;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 0,
    width: 60.78,
    height: 60.78,
    rx: 13.62,
    ry: 13.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.39,50.63h-15.54v-7.02h15.54c2.75,0,5.68-1.39,5.68-3.97,0-2.25-1.52-4.22-3.69-4.8l-9.85-2.44c-5-1.33-8.45-5.83-8.45-10.94,0-6.23,5.07-11.31,11.31-11.31h16.8v7.02h-16.8c-2.36,0-4.28,1.92-4.28,4.28,0,1.94,1.31,3.64,3.18,4.14l9.85,2.44c5.3,1.41,8.96,6.18,8.96,11.6,0,6.27-5.46,11-12.7,11Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaviWhite);
export default __webpack_public_path__ + "static/media/favi_white.43c1378fab4ea9ec653085ad16014b55.svg";
export { ForwardRef as ReactComponent };